module.exports = __webpack_public_path__ + "static/media/failure_1.1f42c4f0.gif";